export const GENERIC_CONCESSION_VALIDATION_ERROR = 'Please complete all required fields.'
